const OS = {
  android: false,
  chromeOS: false,
  cordova: false,
  crosswalk: false,
  desktop: false,
  ejecta: false,
  electron: false,
  iOS: false,
  iOSVersion: 0,
  iPad: false,
  iPadPro: false,
  iPhone: false,
  kindle: false,
  linux: false,
  macOS: false,
  node: false,
  nodeWebkit: false,
  pixelRatio: 1,
  webApp: false,
  windows: false,
  windowsPhone: false,
  tablet: false,
};

function init() {
  const ua = navigator.userAgent;

  OS.iPad = (ua.toLowerCase().indexOf('ipad') !== -1 || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  OS.iPadPro = OS.iPad && (() => {
    const ratio = window.devicePixelRatio || 1;
    const screen = {
        width : window.screen.width * ratio,
        height : window.screen.height * ratio
    };
    return (screen.width === 2048 && screen.height === 2732) || (screen.width === 2732 && screen.height === 2048);
  })();

  if (/Windows/.test(ua)) {
    OS.windows = true;
  } else if (/Mac OS/.test(ua) && !/like Mac OS/.test(ua)) {
    OS.macOS = true;
  } else if (/Android/.test(ua)) {
    OS.android = true;
  } else if (/Linux/.test(ua)) {
    OS.linux = true;
  } else if (/iP[ao]d|iPhone/i.test(ua)) {
    OS.iOS = true;
    navigator.appVersion.match(/OS (\d+)/);
    OS.iOSVersion = parseInt(RegExp.$1, 10);
    OS.iPhone = ua.toLowerCase().indexOf('iphone') !== -1;
    // OS.iPad = ua.toLowerCase().indexOf('ipad') !== -1;
  } else if (/Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk.*Mobile Safari/.test(ua)) {
    OS.kindle = true;
  } else if (/CrOS/.test(ua)) {
    OS.chromeOS = true;
  }
  // https://stackoverflow.com/a/50195587
  // detect through userAgent if the device is a tablet
  if (/(tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua.toLowerCase())) {
    OS.tablet = true;
  }

  if (/Windows Phone/i.test(ua) || /IEMobile/i.test(ua)) {
    OS.android = false;
    OS.iOS = false;
    OS.macOS = false;
    OS.windows = true;
    OS.windowsPhone = true;
  }

  const silk = /Silk/.test(ua);

  // ATENTION: tablet and iPad should be considered "desktop" devices for this project only  
  if (OS.windows || OS.macOS || (OS.linux && !silk) || OS.chromeOS || OS.tablet || OS.iPad) {
    OS.desktop = true;
  }

  //  Windows Phone / Table reset
  if (OS.windowsPhone || (/Windows NT/i.test(ua) && /Touch/i.test(ua))) {
    OS.desktop = false;
  }

  //  WebApp mode in iOS
  // @ts-ignore
  if (navigator.standalone) {
    OS.webApp = true;
  }

  // @ts-ignore
  if (window.cordova !== undefined) {
    OS.cordova = true;
  }

  if (typeof process !== 'undefined' && process.versions && process.versions.node) {
    OS.node = true;
  }

  if (OS.node && typeof process.versions === 'object') {
    OS.nodeWebkit = !!process.versions['node-webkit'];
    // @ts-ignore
    OS.electron = !!process.versions.electron;
  }

  // @ts-ignore
  if (window.ejecta !== undefined) {
    OS.ejecta = true;
  }

  if (/Crosswalk/.test(ua)) {
    OS.crosswalk = true;
  }

  OS.pixelRatio = window.devicePixelRatio || 1;

  return OS;
}

export default init();
